/* eslint-disable jsx-a11y/no-distracting-elements */
import React, { Component } from 'react'
import {FaSearch, FaUserCircle, FaBars, FaCartPlus, FaTh, FaList} from 'react-icons/fa'
import style from '../../assets/css/input.module.css'
import { NavbarBrand, Input, Table, ButtonDropdown, Spinner,
 DropdownMenu, DropdownToggle, DropdownItem, Button, Modal, ModalBody,
 ModalHeader,
 ModalFooter} from 'reactstrap'
 import { AiFillCheckCircle, AiOutlineInbox } from 'react-icons/ai'
import MaterialTitlePanel from "../../components/material_title_panel"
import Sidebar from "../../components/Header";
import SidebarContent from "../../components/sidebar_content"
import stock from '../../redux/actions/stock'
import asset_history from '../../redux/actions/asset_history'
import auth from '../../redux/actions/auth'
import depo from '../../redux/actions/depo'
import tempmail from '../../redux/actions/tempmail'
import status_stock from '../../redux/actions/status_stock'
import {connect} from 'react-redux'
import NavBar from '../../components/NavBar'
import ReactHtmlToExcel from "react-html-table-to-excel"
import styleTrans from '../../assets/css/transaksi.module.css'
import NewNavbar from '../../components/NewNavbar'
import Email from '../../components/Stock/Email'
import moment from 'moment'
import ExcelJS from "exceljs"
import fs from "file-saver"
import StockDashboard from './StockDashboard'

// ─── Helper: filter data per sheet ───────────────────────────────────────────
const isHO        = (p) => p && p.length > 4
const isArea      = (p) => p && p.length <= 4
const sapAda      = (x) => x.status_doc !== 1
const sapTidakAda = (x) => x.status_doc === 1
const fisikAda    = (x) => x.status_fisik === 'ada' || x.new_status === 'Belum submit'
const fisikTidakAda = (x) => x.status_fisik === 'tidak ada'
const sudahKirim  = (x) => x.new_status !== 'Belum submit'
const belumKirim  = (x) => x.new_status === 'Belum submit'
 
function getSheetData(allData) {
    return {
        'ALL':                  allData,
        'REPORT STOCK OPNAME':  allData,
        'SAP=FISIK':            allData.filter(x => sapAda(x) && fisikAda(x) && sudahKirim(x)),
        // 'SAP=FISIK':            allData.filter(x => sapAda(x) && fisikAda(x) && isArea(x.kode_plant) && sudahKirim(x)),
        'SAP=FISIK TGR & HO BDG': allData.filter(x => sapAda(x) && fisikAda(x) && isHO(x.kode_plant) && sudahKirim(x)),
        'SAP ADA FISIK TDK':    allData.filter(x => sapAda(x) && fisikTidakAda(x) && sudahKirim(x)),
        'MUTASI':               allData.filter(x => x.grouping && x.grouping.toUpperCase().includes('MUTASI') && sudahKirim(x)),
        'TDK KIRIM':            allData.filter(x => belumKirim(x)),
        // 'TDK KIRIM':            allData.filter(x => belumKirim(x) && isArea(x.kode_plant)),
        'SAP TDK ADA FISIK ADA': allData.filter(x => sapTidakAda(x) && fisikAda(x)),
        'IDLE':                 allData.filter(x => x.grouping && (x.grouping.toUpperCase().includes('TIDAK TERPAKAI') || x.grouping.toUpperCase().includes('IDLE'))),
        'RUSAK':                allData.filter(x => x.kondisi && x.kondisi.toLowerCase() === 'rusak'),
        'HILANG':               allData.filter(x => x.grouping && x.grouping.toUpperCase().includes('HILANG')),
    }
}
 
// ─── Helper: build summary sheet rows (same logic as SummaryOpname) ──────────
function buildSummaryData(allData) {
    const toNum = (v) => { const n = parseFloat(v); return isNaN(n) ? 0 : n }
    const sum   = (arr) => ({
        acquis: arr.reduce((s, x) => s + toNum(x.nilai_acquis), 0),
        accum:  arr.reduce((s, x) => s + toNum(x.accum_dep),   0),
        buku:   arr.reduce((s, x) => s + toNum(x.nilai_buku),  0),
        unit:   arr.length,
    })
 
    const sudahKirimArr     = allData.filter(x => x.new_status !== 'Belum submit')
    const areaTidakKirimArr = allData.filter(x => x.new_status === 'Belum submit')
    // const areaTidakKirimArr = allData.filter(x => isArea(x.kode_plant) && x.new_status === 'Belum submit')
 
    const sapFisikArea   = allData.filter(x => sapAda(x) && fisikAda(x) && isArea(x.kode_plant) && sudahKirim(x))
    const sapFisikHO     = allData.filter(x => sapAda(x) && fisikAda(x) && isHO(x.kode_plant)   && sudahKirim(x))
    const sapAdaFisikTdk = allData.filter(x => sapAda(x) && fisikTidakAda(x)                     && sudahKirim(x))
    const assetMutasi    = allData.filter(x => x.grouping && x.grouping.toUpperCase().includes('MUTASI') && sudahKirim(x))
 
    const totalRekon     = sum(sudahKirimArr)
    const areaTidakKirim = sum(areaTidakKirimArr)
    const totalSAP       = {
        acquis: totalRekon.acquis + areaTidakKirim.acquis,
        accum:  totalRekon.accum  + areaTidakKirim.accum,
        buku:   totalRekon.buku   + areaTidakKirim.buku,
        unit:   totalRekon.unit   + areaTidakKirim.unit,
    }
 
    const areaTidakKirimAreaCount = new Set(areaTidakKirimArr.filter(x => isArea(x.kode_plant)).map(x => x.kode_plant).filter(Boolean)).size
    const areaTidakKirimHOCount   = new Set(areaTidakKirimArr.filter(x => isHO(x.kode_plant)).map(x => x.kode_plant).filter(Boolean)).size
 
    // Count items
    const idle   = allData.filter(x => x.grouping && (x.grouping.toUpperCase().includes('TIDAK TERPAKAI') || x.grouping.toUpperCase().includes('IDLE'))).length
    const rusak  = allData.filter(x => x.kondisi && x.kondisi.toLowerCase() === 'rusak').length
    const hilang = allData.filter(x => x.grouping && x.grouping.toUpperCase().includes('HILANG')).length
    const hilangArea = allData.filter(x => x.grouping && x.grouping.toUpperCase().includes('HILANG') && isArea(x.kode_plant)).length
    const hilangHO   = allData.filter(x => x.grouping && x.grouping.toUpperCase().includes('HILANG') && isHO(x.kode_plant)).length
 
    // Area clear/tidak clear
    const areaPlants    = [...new Set(allData.filter(x => x.kode_plant).map(x => x.kode_plant).filter(Boolean))]
    // const areaPlants    = [...new Set(allData.filter(x => isArea(x.kode_plant)).map(x => x.kode_plant).filter(Boolean))]
    const unclearPlants = areaPlants.filter(p => allData.some(x => x.kode_plant === p && x.clear_flag === 'unclear'))
    const clearPlants   = areaPlants.filter(p => !unclearPlants.includes(p))
 
    return {
        sapFisikArea:    sum(sapFisikArea),
        sapFisikHO:      sum(sapFisikHO),
        sapAdaFisikTdk:  sum(sapAdaFisikTdk),
        assetMutasi:     sum(assetMutasi),
        totalRekon,
        areaTidakKirim,
        areaTidakKirimAreaCount,
        areaTidakKirimHOCount,
        totalSAP,
        idle, rusak, hilang, hilangArea, hilangHO,
        areaClear:        clearPlants.length,
        areaTidakClear:   unclearPlants.length,
        totalAreaNasional: areaPlants.length,
        pctClear:         areaPlants.length > 0 ? Math.round(clearPlants.length / areaPlants.length * 100) : 0,
        pctTidakClear:    areaPlants.length > 0 ? Math.round(unclearPlants.length / areaPlants.length * 100) : 0,
    }
}
 
// ─── Helper: add data sheet ───────────────────────────────────────────────────
function addDataSheet(workbook, sheetName, data, totals, borderStyles) {
    const ws = workbook.addWorksheet(sheetName)
 
    // 3 blank rows sebelum header (header mulai row 4)
    ws.addRow([])
    ws.addRow([])
    ws.addRow([])
 
    // Set kolom tanpa header property, lalu tambah header row manual di row 4
    const cols = [
        { key: 'c1',  width: 6  },
        { key: 'c2',  width: 18 },
        { key: 'c3',  width: 30 },
        { key: 'c4',  width: 15 },
        { key: 'c5',  width: 12 },
        { key: 'c6',  width: 14 },
        { key: 'c7',  width: 20 },
        { key: 'c8',  width: 10 },
        { key: 'c9',  width: 8  },
        { key: 'c10', width: 20 },
        { key: 'c11', width: 14 },
        { key: 'c12', width: 14 },
        { key: 'c13', width: 12 },
        { key: 'c14', width: 20 },
        { key: 'c15', width: 18 },
        { key: 'c16', width: 18 },
        { key: 'c17', width: 18 },
        { key: 'c18', width: 20 },
        { key: 'c19', width: 14 },
        { key: 'c20', width: 20 },
    ]
    ws.columns = cols
 
    const headerRow = ws.addRow({
        c1: 'No', c2: 'ASSET', c3: 'DESKRIPSI', c4: 'MERK', c5: 'PLANT',
        c6: 'COST CENTER', c7: 'AREA', c8: 'SATUAN', c9: 'UNIT', c10: 'LOKASI',
        c11: 'STATUS SAP', c12: 'STATUS FISIK', c13: 'KONDISI', c14: 'GROUPING',
        c15: 'ACQUIS VAL', c16: 'ACCUM DEP', c17: 'BOOK VAL',
        c18: 'KETERANGAN', c19: 'STATUS ASSET', c20: 'STATUS',
    })
    headerRow.font = { bold: true }
    headerRow.eachCell(cell => { cell.border = borderStyles })
 
    data.forEach((item, index) => {
        const row = ws.addRow({
            c1:  index + 1,
            c2:  item.no_asset,
            c3:  item.deskripsi,
            c4:  item.merk,
            c5:  item.kode_plant,
            c6:  item.cost_center,
            c7:  item.area,
            c8:  item.satuan,
            c9:  item.unit,
            c10: item.lokasi,
            c11: item.new_status === 'Belum submit' ? 'ADA' : item.status_doc === 1 ? 'TIDAK ADA' : 'ADA',
            c12: item.status_fisik,
            c13: item.kondisi,
            c14: item.grouping,
            c15: item.nilai_acquis,
            c16: item.accum_dep,
            c17: item.nilai_buku,
            c18: item.keterangan,
            c19: item.clear_flag,
            c20: item.new_status,
        })
        row.eachCell({ includeEmpty: true }, cell => { cell.border = borderStyles })
    })
 
    // Total row
    const totalRow = ws.addRow({
        c14: 'TOTAL :',
        c15: totals.acquis,
        c16: totals.accum,
        c17: totals.buku,
    })
    totalRow.font = { bold: true }
    totalRow.eachCell({ includeEmpty: true }, cell => { cell.border = borderStyles })
}
 
// ─── Helper: add summary sheet ────────────────────────────────────────────────
function addSummarySheet(workbook, s, periodeLabel, borderStyles) {
    const ws = workbook.addWorksheet('SUMMARY')
    const toNum = (v) => { const n = parseFloat(v); return isNaN(n) ? 0 : n }
    const fmtNum = (n) => Math.round(toNum(n))
 
    ws.columns = [
        { key: 'label',    width: 55 },
        { key: 'acquis',   width: 22 },
        { key: 'accum',    width: 22 },
        { key: 'buku',     width: 22 },
        { key: 'eksekusi', width: 30 },
    ]
 
    // Row 1: blank
    ws.addRow([])
    // Row 2: title
    const titleRow = ws.addRow({ label: `OPNAME ASSET ${periodeLabel.toUpperCase()}` })
    titleRow.font = { bold: true, size: 13 }
    titleRow.alignment = { horizontal: 'center' }
    ws.mergeCells(`A${titleRow.number}:E${titleRow.number}`)
    titleRow.eachCell({ includeEmpty: true }, cell => { cell.border = borderStyles })
    // Row 3: blank
    ws.addRow([])
    // Row 4: header kolom
    const headerRow = ws.addRow({ label: 'REKAPITULASI', acquis: 'Acquis.val.', accum: 'Accum.dep.', buku: 'Book val.', eksekusi: 'EKSEKUSI' })
    headerRow.font = { bold: true }
    headerRow.eachCell({ includeEmpty: true }, cell => { cell.border = borderStyles })
 
    const addRow = (label, vals, eksekusi, bold, bg) => {
        const row = ws.addRow({
            label,
            acquis:   vals ? fmtNum(vals.acquis) : null,
            accum:    vals ? fmtNum(vals.accum)  : null,
            buku:     vals ? fmtNum(vals.buku)   : null,
            eksekusi: eksekusi || (vals && vals.unit > 0 ? `${vals.unit} unit` : null),
        })
        row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
            cell.border = borderStyles
            if (bold) cell.font = { bold: true }
            if (bg)   cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: bg } }
            // kolom 2,3,4 = acquis, accum, buku — kasih separator
            if (colNumber >= 2 && colNumber <= 4 && typeof cell.value === 'number') {
                cell.numFmt = '#,##0'
            }
        })
        return row
    }
 
    const addBlank = () => {
        const row = ws.addRow({})
        row.eachCell({ includeEmpty: true }, cell => { cell.border = borderStyles })
    }
 
    // Section 1: Rekap Nilai
    addRow('SAP = FISIK AREA',    s.sapFisikArea)
    addRow('SAP = FISIK HO',      s.sapFisikHO)
    addRow('SAP ADA FISIK TIDAK', s.sapAdaFisikTdk,  null, false, 'FFFFF0F0')
    addRow('SAP ADA FISIK TIDAK - KENDARAAN', { acquis: 0, accum: 0, buku: 0, unit: 0 }, null, false, 'FFFFF0F0')
    addRow('ASSET MUTASI',        s.assetMutasi)
    addRow('Total Rekonsiliasi Hasil Opname AREA NASIONAL & HO TGR NON IT', s.totalRekon, null, true, 'FFF0F0F0')
    addRow('Total Area yang tidak kirim', s.areaTidakKirim,
        `${s.areaTidakKirim.unit} unit; ${s.areaTidakKirimAreaCount} area; ${s.areaTidakKirimHOCount} ho`,
        true, 'FFF0F0F0'
    )
    addRow(`Asset Balance SAP per 26 ${periodeLabel}`, s.totalSAP, null, false, 'FFFAFAFA')
    addRow('Balance Checked', null, '-', true, 'FFFCE8E8')
 
    addBlank()
 
    // Section 2: Count items
    addRow('IDLE',  { acquis: 0, accum: 0, buku: 0 }, s.idle  > 0 ? `${s.idle} unit`  : '-')
    addRow('RUSAK', { acquis: 0, accum: 0, buku: 0 }, s.rusak > 0 ? `${s.rusak} unit` : '-')
    addRow('FISIK ADA SAP TIDAK ADA - Asset Belum di GR',       { acquis: 0, accum: 0, buku: 0 }, '-')
    addRow('FISIK ADA SAP TIDAK ADA - Asset Belum Terdaftar',   { acquis: 0, accum: 0, buku: 0 }, '-')
    addRow('FISIK ADA SAP TIDAK ADA - Tidak ada nomor Asset',   { acquis: 0, accum: 0, buku: 0 }, '-')
    addRow('HILANG', { acquis: 0, accum: 0, buku: 0 },
        s.hilang > 0 ? `${s.hilang} unit; unit area ${s.hilangArea}; unit ho ${s.hilangHO}` : '-'
    )
 
    addBlank()
 
    // Section 3: Area Clear
    addRow('Area Clear',         null, `${s.areaClear} (${s.pctClear}%)`,           true, 'FFE8F5F0')
    addRow('Area Tidak Clear',   null, `${s.areaTidakClear} (${s.pctTidakClear}%)`, true, 'FFFCE8E8')
    addRow('Total Area Nasional',null, `${s.totalAreaNasional} (100%)`,              true)
}

class ReportStock extends Component {
    constructor(props) {
        super(props);
        this.state = {
            docked: false,
            open: false,
            transitions: true,
            touch: true,
            shadow: true,
            pullRight: false,
            touchHandleWidth: 20,
            dragToggleDistance: 30,
            tipe: 'report',
            group: '',
            fisik: '',
            sap: '',
            kondisi: '',
            limit: 'all',
            dropOpen: false,
            nilai_buku: 0,
            accum_dep: 0,
            nilai_acquis: 0,
            drop: false,
            dropBtn: false,
            dropCond: false,
            plant: '',
            areaDrop: false,
            time: 'pilih',
            time1: moment().subtract(1, 'month').format('YYYY-MM-24'),
            time2: moment().endOf('month').format('YYYY-MM-25'),
            selectMonth: moment().format('DD') < 25 ? moment().month() : moment().month() + 1,
            selectYear: moment().year(),
            newReport: [],
            baseReport: [],
            isLoading: false,
            dataIssue: [],
            modalIssue: false,
            listIssue: [],
            openDraft: false,
            subject: '',
            message: '',
            modalConfirm: false,
            confirm: '',
            typeReport: 'dashboard',
        }
        this.onSetOpen = this.onSetOpen.bind(this);
        this.menuButtonClick = this.menuButtonClick.bind(this);
    }

    getMessage = (val) => {
        this.setState({ message: val.message, subject: val.subject })
        console.log(val)
    }

    issueApp = (val) => {
        const { listIssue, dataIssue } = this.state
        if (val === 'all') {
            const data = []
            for (let i = 0; i < dataIssue.length; i++) {
                data.push(dataIssue[i].id)
            }
            this.setState({listIssue: data})
        } else {
            listIssue.push(val)
            this.setState({listIssue: listIssue})
        }
    }

    issueRej = (val) => {
        const { listIssue } = this.state
        if (val === 'all') {
            const data = []
            this.setState({listIssue: data})
        } else {
            const data = []
            for (let i = 0; i < listIssue.length; i++) {
                if (listIssue[i] === val) {
                    data.push()
                } else {
                    data.push(listIssue[i])
                }
            }
            this.setState({listIssue: data})
        }
    }

    selectTime = (val) => {
        this.setState({[val.type]: val.val})
    }

    handleMonth = (e) => {
        console.log(e.target.value)
        const selectMonth = e.target.value
        const { selectYear } = this.state
        const time1 = moment(`${selectYear}-${selectMonth}-26`, "YYYY-M-DD").format('YYYY-MM-DD')
        const time2 = moment(`${selectYear}-${(parseInt(selectMonth) + 1)}-25`, "YYYY-M-DD").format('YYYY-MM-DD')
        console.log(time1)
        console.log(time2)
        this.setState({ selectMonth: selectMonth, time1: time1, time2: time2 });
    };

    handleYear = (e) => {
        console.log(e.target.value)
        const selectYear = e.target.value
        const { selectMonth } = this.state
        const time1 = moment(`${selectYear}-${selectMonth}-26`, "YYYY-M-DD").format('YYYY-MM-DD')
        const time2 = moment(`${selectYear}-${(parseInt(selectMonth) + 1)}-25`, "YYYY-M-DD").format('YYYY-MM-DD')
        console.log(time1)
        console.log(time2)
        this.setState({ selectYear: selectYear, time1: time1, time2: time2 });
    };

    prosesSidebar = (val) => {
        this.setState({sidebarOpen: val})
    }
    
    goRoute = (val) => {
        this.props.history.push(`/${val}`)
    }

    menuButtonClick(ev) {
        ev.preventDefault();
        this.onSetOpen(!this.state.open);
    }

    onSetOpen(open) {
        this.setState({ open });
    }

    async componentDidMount () {
        const token = localStorage.getItem("token")
        await this.props.getAllStatusStock(token)
        await this.props.getDropdown(token)
        await this.props.getDepo(token, 10000, '', 1)
        
        this.getDataStock({limit: 'all', search: '', group: 'all', sap: 'all', fisik: 'all', kondisi: 'all', plant: 'all'})
    }

    dropBut = () => {
        this.setState({dropBtn: !this.state.dropBtn})
    }

    dropKondisi = () => {
        this.setState({dropCond: !this.state.dropCond})
    }

    dropOpen = () => {
        this.setState({drop: !this.state.drop})
    }

    dropDown = () => {
        this.setState({dropOpen: !this.state.dropOpen})
    }

    dropArea = () => {
        this.setState({areaDrop: !this.state.areaDrop})
    }

    changeTime = async (val) => {
        const token = localStorage.getItem("token")
        this.setState({time: val})
        if (val === 'all') {
            this.setState({time1: '', time2: ''})
            setTimeout(() => {
                this.getDataTime()
             }, 500)
        }
    }

    getDataTime = async () => {
        const {time1, time2, filter, search, limit} = this.state
        const cekTime1 = time1 === '' ? 'undefined' : time1
        const cekTime2 = time2 === '' ? 'undefined' : time2
        const token = localStorage.getItem("token")
        const level = localStorage.getItem("level")
        const {group, sap, fisik, kondisi, plant} = this.state
        // const status = filter === 'selesai' ? '8' : filter === 'available' && level === '2' ? '1' : filter === 'available' && level === '8' ? '3' : 'all'
        this.getDataStock({group: group, sap: sap, fisik: fisik, kondisi: kondisi, plant: plant})
    }

    getDataStock = async (value) => {
        this.setState({isLoading: true})
        const token = localStorage.getItem("token")
        const {time1, time2} = this.state
        const cekTime1 = time1 === '' ? 'undefined' : time1
        const cekTime2 = time2 === '' ? 'undefined' : time2
        const { pageRep } = this.props.stock
        const search = value === undefined ? '' : value.search
        const limit = value === undefined ? this.state.limit : value.limit
        const group = value === undefined ? this.state.group : value.group
        await this.props.getAsset(token, 'all', '', 1, 'master', cekTime1, cekTime2)
        await this.props.getReportAll(token, search, limit, pageRep === undefined ? 1 : pageRep.currentPage, group, value.fisik, value.sap, value.kondisi, value.plant, cekTime1, cekTime2)
        await this.props.getStatusAll(token)
        const { dataRep } = this.props.stock
        const { dataAsset } = this.props.asset_history
        this.setState({group: value.group, sap: value.sap, fisik: value.fisik, kondisi: value.kondisi, plant: value.plant})
        let buku = 0
        let acquis = 0
        let accum = 0
        const newData = []
        const { dataDepo } = this.props.depo
        for (let i = 0; i < dataAsset.length; i++) {
            const asset = dataAsset[i]
            buku += parseFloat(asset.nilai_buku)
            acquis += parseFloat(asset.nilai_acquis)
            accum += parseFloat(asset.accum_dep)
            const cek = dataRep.find(x => x.no_asset === asset.no_asset && x.status_doc !== 1)
            const cekApp = dataRep.find(x => x.no_asset === asset.no_asset && x.status_doc !== 1 && x.status_reject !== 1)
            const dataSelect = cekApp ? 'cekApp' : cek ? 'cek' : 'not_found'
            const dataFinal = dataSelect === 'not_found' ? {
                ...asset,
                deskripsi: asset.nama_asset,
                new_status: asset.status === '0' ? 'Aset telah Disposal' : 'Belum submit'
            } : dataSelect === 'cekApp' ? {
                ...cekApp,
                nilai_acquis: asset.nilai_acquis,
                accum_dep: asset.accum_dep,
                nilai_buku: asset.nilai_buku,
                cost_center: asset.cost_center,
                new_status: asset.status === '0' ? 'Aset telah Disposal' : cekApp.status_form === 8 ? 'Finish' : 'In Progress'
            } : {
                ...cek,
                nilai_acquis: asset.nilai_acquis,
                accum_dep: asset.accum_dep,
                nilai_buku: asset.nilai_buku,
                cost_center: asset.cost_center,
                new_status: asset.status === '0' ? 'Aset telah Disposal' : cek.status_form === 0 ? 'Rejected' : cek.status_reject === 1 && cek.status_form !== 0 ? 'Revisi' : 'In Progress'
            }
            newData.push(dataFinal)
        }

        const newAdditional = [] 
        const dataAdditional = dataRep.filter(item => item.status_doc === 1)
        for (let i = 0; i < dataAdditional.length; i++) {
            const addition = dataAdditional[i]
            const selectDepo = dataDepo.find(x => x.kode_plant === addition.kode_plant)
            const send = {
                ...addition,
                nilai_acquis: 0,
                accum_dep: 0,
                nilai_buku: 0,
                cost_center: selectDepo ? selectDepo.cost_center : '',
                new_status: addition.status_form === 0 ? 'Rejected (Asset Tambahan)' : addition.status_reject === 1 && addition.status_form !== 0 ? 'Revisi (Asset Tambahan)' : addition.status_form === 8 ? 'Finish (Asset Tambahan)': 'In Progress (Asset Tambahan)'
            }
            newAdditional.push(send)
        }

        const newReport = [
            ...newData,
            ...newAdditional
        ]

        console.log(newReport[0].area)

        setTimeout(() => {
            this.setState({limit: value === undefined ? 10 : value.limit, nilai_buku: buku, nilai_acquis: acquis, accum_dep: accum, newReport: newReport, baseReport: newReport})
        }, 100)
        this.setState({isLoading: false})
    }

    prosesOpenIssue = async () => {
        const { baseReport } = this.state
        const { dataDropdown, dataStatusStock } = this.props.status_stock
        const newData = baseReport.filter(item => {
            const cekDropdown = dataDropdown.find(x => x.description === item.notes_dropdown)
            const cekStatus = dataStatusStock.find(x => x.status === item.grouping)
            if ((cekDropdown && cekDropdown.mark) || (cekStatus && cekStatus.is_dropdown)) {
                return ({...item, fu_issue: ''})
            }
        })
        this.setState({ dataIssue: newData })
        this.openIssue()
    }

    prepSendEmail = async () => {
        const { listIssue, dataIssue } = this.state
        const token = localStorage.getItem('token')
        const listPlant = dataIssue.map(item => listIssue.find(x => x === item.id) && item.kode_plant) 
        const tempno = {
            kode: [...new Set(listPlant)],
            jenis: 'stock',
            tipe: 'issue_stock',
            menu: 'Report Stock Opname (Stock Opname asset)'
        }
        await this.props.getDraftEmail(token, tempno)
        this.openDraftEmail()
    }

    openDraftEmail = () => {
        this.setState({openDraft: !this.state.openDraft}) 
    }

    openIssue = () => {
        const {modalIssue} = this.state
        this.setState({ modalIssue: !modalIssue, newReport: modalIssue ? this.state.baseReport : [], listIssue: [] })
    }

    sendEmailIssue = async () => {
        const token = localStorage.getItem('token')
        const { draftEmail } = this.props.tempmail
        const { message, subject, dataIssue, listIssue } = this.state
        const cc = draftEmail.cc
        const tempcc = cc.map(x => x.email)
        const tempto = draftEmail.to.map(x => x.email)
        const listName = draftEmail.to.map(x => x.fullname)
        const sendMail = {
            draft: draftEmail,
            nameTo: listName.toString(),
            to: tempto.toString(),
            cc: tempcc.toString(),
            message: message,
            subject: subject,
            tipe: 'issue_stock',
            menu: `Report Stock Opname (Stock Opname asset)`,
            proses: 'submit',
            route: 'stock',
            listData: dataIssue.filter(item => listIssue.find(x => x === item.id))
        }
        await this.props.sendEmail(token, sendMail)
        this.openIssue()
        this.openDraftEmail()
        this.setState({ confirm: 'success' })
        this.openConfirm()
    }

    openConfirm = () => {
        this.setState({ modalConfirm: !this.state.modalConfirm })
    }

    onSearch = async (e) => {
        this.setState({ search: e.target.value })

        if (e.key === 'Enter') {
            const { baseReport } = this.state
            const keyword = e.target.value.toLowerCase()

            const findData = baseReport.filter(x => 
                x.no_asset?.toLowerCase().includes(keyword) ||
                x.deskripsi?.toLowerCase().includes(keyword) ||
                x.nama_asset?.toLowerCase().includes(keyword) ||
                x.cost_center?.toLowerCase().includes(keyword) ||
                x.kode_plant?.toLowerCase().includes(keyword)
            )

            if (keyword === '') {
                this.setState({ newReport: baseReport })
            } else if (findData.length > 0) {
                this.setState({ newReport: findData })
            } else {
                this.setState({ newReport: [] })
            }
        }
    }


    // downloadReport = async (val) => {
    //     this.setState({isLoading: true})
    //     const { dataRep, pageRep, dataAll } = this.props.stock
    //     const { newReport } = this.state
    //     const dataDownload = newReport

    //     const workbook = new ExcelJS.Workbook();
    //     const ws = workbook.addWorksheet('report stock opname')

    //     // await ws.protect('F1n4NcePm4')

    //     const borderStyles = {
    //         top: {style:'thin'},
    //         left: {style:'thin'},
    //         bottom: {style:'thin'},
    //         right: {style:'thin'}
    //     }


    //     ws.columns = [
    //         {header: 'No', key: 'c1'},
    //         {header: 'ASSET', key: 'c2'},
    //         {header: 'DESKRIPSI', key: 'c3'},
    //         {header: 'MERK', key: 'c4'},
    //         {header: 'PLANT', key: 'c5'},
    //         {header: 'COST CENTER', key: 'c6'},
    //         {header: 'AREA', key: 'c7'},
    //         {header: 'SATUAN', key: 'c8'},
    //         {header: 'UNIT', key: 'c9'},
    //         {header: 'LOKASI', key: 'c10'},
    //         {header: 'STATUS SAP', key: 'c11'},
    //         {header: 'STATUS FISIK', key: 'c12'},
    //         {header: 'KONDISI', key: 'c13'},
    //         {header: 'GROUPING', key: 'c14'},
    //         {header: 'ACQUIS VAL', key: 'c15'},
    //         {header: 'ACCUM DEP', key: 'c16'},
    //         {header: 'BOOK VAL', key: 'c17'},
    //         {header: 'KETERANGAN', key: 'c18'},
    //         {header: 'STATUS ASSET', key: 'c19'},
    //         {header: 'STATUS', key: 'c20'}
    //     ]

    //     dataDownload.map((item, index) => { return ( ws.addRow(
    //         {
    //             c1: index + 1,
    //             c2: item.no_asset,
    //             c3: item.deskripsi,
    //             c4: item.merk,
    //             c5: item.kode_plant,
    //             c6: item.cost_center,
    //             c7: item.area,
    //             c8: item.satuan,
    //             c9: item.unit,
    //             c10: item.lokasi,
    //             c11: item.new_status === 'Belum submit' ? 'ADA' : item.status_doc === 1 ? 'TIDAK ADA' : 'ADA',
    //             c12: item.status_fisik,
    //             c13: item.kondisi,
    //             c14: item.grouping,
    //             c15: item.nilai_acquis,
    //             c16: item.accum_dep,
    //             c17: item.nilai_buku,
    //             c18: item.keterangan,
    //             c19: item.clear_flag,
    //             c20: item.new_status
    //         }
    //     )
    //     ) })
        

    //     ws.addRow(
    //         {
    //             c14: 'TOTAL :',
    //             c15: this.state.nilai_acquis,
    //             c16: this.state.accum_dep,
    //             c17: this.state.nilai_buku,
    //         }
    //     )

    //     ws.eachRow({ includeEmpty: true }, function(row, rowNumber) {
    //         row.eachCell({ includeEmpty: true }, function(cell, colNumber) {
    //           cell.border = borderStyles;
    //         })
    //       })

    //     ws.columns.forEach(column => {
    //         const lengths = column.values.map(v => v.toString().length)
    //         const maxLength = Math.max(...lengths.filter(v => typeof v === 'number'))
    //         column.width = maxLength + 5
    //     })

    //     workbook.xlsx.writeBuffer().then(function(buffer) {
    //         fs.saveAs(
    //           new Blob([buffer], { type: "application/octet-stream" }),
    //           `Report Stock Opname ${moment().format('DD MMMM YYYY')}.xlsx`
    //         );
    //     });
        
    //     this.setState({isLoading: false})
    // }

    downloadReport = async (val) => {
        this.setState({ isLoading: true })
        const { newReport, nilai_acquis, accum_dep, nilai_buku } = this.state
        const toNum = (v) => { const n = parseFloat(v); return isNaN(n) ? 0 : n }
    
        const borderStyles = {
            top: { style: 'thin' }, left: { style: 'thin' },
            bottom: { style: 'thin' }, right: { style: 'thin' },
        }
    
        const workbook   = new ExcelJS.Workbook()
        const sheetMap   = getSheetData(newReport)
        const summaryData = buildSummaryData(newReport)
    
        // Hitung totals per sheet
        const getTotals = (data) => ({
            acquis: data.reduce((s, x) => s + toNum(x.nilai_acquis), 0),
            accum:  data.reduce((s, x) => s + toNum(x.accum_dep),   0),
            buku:   data.reduce((s, x) => s + toNum(x.nilai_buku),  0),
        })
    
        const periodeLabel = moment().format('MMMM YYYY')
    
        addSummarySheet(workbook, summaryData, periodeLabel, borderStyles)
    
        const sheetOrder = [
            'SAP=FISIK',
            'SAP=FISIK TGR & HO BDG',
            'SAP ADA FISIK TDK',
            'MUTASI',
            'TDK KIRIM',
            'SAP TDK ADA FISIK ADA',
            'REPORT STOCK OPNAME',
            'IDLE',
            'RUSAK',
            'HILANG',
            'ALL',
        ]
    
        sheetOrder.forEach(name => {
            const data = sheetMap[name] || []
            addDataSheet(workbook, name, data, getTotals(data), borderStyles)
        })
    
        workbook.xlsx.writeBuffer().then(function (buffer) {
            fs.saveAs(
                new Blob([buffer], { type: 'application/octet-stream' }),
                `Report Stock Opname ${moment().format('DD MMMM YYYY')}.xlsx`
            )
        })
    
        this.setState({ isLoading: false })
    }

    handleFu = (e, id) => {
        const { name, value } = e.target

        this.setState(prevState => ({
            dataIssue: prevState.dataIssue.map(item =>
            item.id === id
                ? { ...item, [name]: value }
                : item
            )
        }))
    }

    changeType = (val) => {
        this.setState({typeReport: val})
    }

    render() {
        const { dataDepo } = this.props.depo
        const level = localStorage.getItem('level')
        const names = localStorage.getItem('name')
        const { dataRep, pageRep, dataAll } = this.props.stock
        const { dataAsset } = this.props.asset_history
        const { newReport, isLoading, dataIssue, listIssue } = this.state
        const loadingDepo = this.props.depo.isLoading
        const loadingAsset = this.props.asset_history.isLoading
        const loadingStock = this.props.stock.isLoading
        const loadingTempmail = this.props.tempmail.isLoading
        const isLoadingAll = loadingDepo || loadingAsset || loadingStock || isLoading || loadingTempmail
        const { dataDropdown, dataStatusStock } = this.props.status_stock
        const months = moment.locale("id") && moment.months();
        const currentYear = moment().year(); 
        const years = [];

        for (let year = 2000; year <= currentYear; year++) {
            years.push(year);
        }


        const contentHeader =  (
            <div className={style.navbar}>
                <NavbarBrand
                href="#"
                onClick={this.menuButtonClick}
                >
                    <FaBars size={20} className={style.white} />
                </NavbarBrand>
                <NavBar />
            </div>
        )

        const sidebar = <SidebarContent />
        const sidebarProps = {
            sidebar,
            docked: this.state.docked,
            sidebarClassName: "custom-sidebar-class",
            contentId: "custom-sidebar-content-id",
            open: this.state.open,
            touch: this.state.touch,
            shadow: this.state.shadow,
            pullRight: this.state.pullRight,
            touchHandleWidth: this.state.touchHandleWidth,
            dragToggleDistance: this.state.dragToggleDistance,
            transitions: this.state.transitions,
            onSetOpen: this.onSetOpen
          };

        return (
            <>
                <div className={styleTrans.app}>
                    <NewNavbar handleSidebar={this.prosesSidebar} handleRoute={this.goRoute} />

                    <div className={`${styleTrans.mainContent} ${this.state.sidebarOpen ? styleTrans.collapsedContent : ''}`}>
                        <h2 className={styleTrans.pageTitle}>Report Stock Opname</h2>
                        <div className='mb-4'></div>
                        {this.state.typeReport === 'detail_report' ? (
                            <>
                                <div className={styleTrans.searchContainer}>
                                    <div className='rowGeneral'>
                                        <div>
                                            <text>Status Fisik: </text>
                                            <ButtonDropdown className={style.drop} isOpen={this.state.drop} toggle={this.dropOpen}>
                                            <DropdownToggle caret color="light">
                                                {this.state.fisik === '' ? 'Pilih status fisik' : this.state.fisik}
                                            </DropdownToggle>
                                            <DropdownMenu>
                                                <DropdownItem className={style.item} onClick={() => this.getDataStock({limit: 'all', search: '', group: this.state.group, sap: this.state.sap, fisik: 'all', kondisi: this.state.kondisi, plant: this.state.plant})}>All</DropdownItem>
                                                <DropdownItem className={style.item} onClick={() => this.getDataStock({limit: 'all', search: '', group: this.state.group, sap: this.state.sap, fisik: 'ada', kondisi: this.state.kondisi, plant: this.state.plant})}>Ada</DropdownItem>
                                                <DropdownItem className={style.item} onClick={() => this.getDataStock({limit: 'all', search: '', group: this.state.group, sap: this.state.sap, fisik: 'tidak ada', kondisi: this.state.kondisi, plant: this.state.plant})}>Tidak Ada</DropdownItem>
                                            </DropdownMenu>
                                            </ButtonDropdown>
                                        </div>
                                        <div className='ml-3' >
                                            <text>Kondisi: </text>
                                            <ButtonDropdown className={style.drop} isOpen={this.state.dropCond} toggle={this.dropKondisi}>
                                            <DropdownToggle caret color="light">
                                                {this.state.kondisi === '' ? 'Pilih status fisik' : this.state.kondisi}
                                            </DropdownToggle>
                                            <DropdownMenu>
                                                <DropdownItem className={style.item} onClick={() => this.getDataStock({limit: 'all', search: '', group: this.state.group, sap: this.state.sap, fisik: this.state.fisik, kondisi: 'all', plant: this.state.plant})}>All</DropdownItem>
                                                <DropdownItem className={style.item} onClick={() => this.getDataStock({limit: 'all', search: '', group: this.state.group, sap: this.state.sap, fisik: this.state.fisik, kondisi: '', plant: this.state.plant})}>-</DropdownItem>
                                                <DropdownItem className={style.item} onClick={() => this.getDataStock({limit: 'all', search: '', group: this.state.group, sap: this.state.sap, fisik: this.state.fisik, kondisi: 'baik', plant: this.state.plant})}>Baik</DropdownItem>
                                                <DropdownItem className={style.item} onClick={() => this.getDataStock({limit: 'all', search: '', group: this.state.group, sap: this.state.sap, fisik: this.state.fisik, kondisi: 'rusak', plant: this.state.plant})}>Rusak</DropdownItem>
                                            </DropdownMenu>
                                            </ButtonDropdown>
                                        </div>
                                    </div>
                                    <div className='rowGeneral'>
                                        <Button color='primary' size='lg' onClick={() => this.prosesOpenIssue()}>
                                            Issue
                                        </Button>
                                        <Button color='success' size='lg' className='ml-2' onClick={this.downloadReport}>
                                            Download
                                        </Button>
                                    </div>
                                </div>
                                <div className={styleTrans.searchContainer}>
                                    <div className='rowGeneral'>
                                        <div className='' >
                                            <text>Status SAP: </text>
                                            <ButtonDropdown className={style.drop} isOpen={this.state.dropBtn} toggle={this.dropBut}>
                                            <DropdownToggle caret color="light">
                                                {this.state.sap === '' ? 'Pilih status sap' : this.state.sap === 'null' ? 'Tidak ada' : this.state.sap}
                                            </DropdownToggle>
                                            <DropdownMenu>
                                                <DropdownItem className={style.item} onClick={() => this.getDataStock({limit: 'all', search: '', group: this.state.group, sap: 'all', fisik: this.state.fisik, kondisi: this.state.kondisi, plant: this.state.plant})}>All</DropdownItem>
                                                <DropdownItem className={style.item} onClick={() => this.getDataStock({limit: 'all', search: '', group: this.state.group, sap: 'ada', fisik: this.state.fisik, kondisi: this.state.kondisi, plant: this.state.plant})}>Ada</DropdownItem>
                                                <DropdownItem className={style.item} onClick={() => this.getDataStock({limit: 'all', search: '', group: this.state.group, sap: 'null', fisik: this.state.fisik, kondisi: this.state.kondisi, plant: this.state.plant})}>Tidak Ada</DropdownItem>
                                            </DropdownMenu>
                                            </ButtonDropdown>
                                        </div>
                                        <div className='ml-3'>
                                            <text>Status Aset: </text>
                                            <ButtonDropdown className={style.drop} isOpen={this.state.dropOpen} toggle={this.dropDown}>
                                            <DropdownToggle caret color="light">
                                                {this.state.group === '' ? 'Pilih status aset' :  this.state.group}
                                            </DropdownToggle>
                                            <DropdownMenu>
                                                <DropdownItem className={style.item} onClick={() => this.getDataStock({limit: 'all', search: '', group: 'all', sap: this.state.sap, fisik: this.state.fisik, kondisi: this.state.kondisi, plant: this.state.plant})}>All</DropdownItem>
                                                {dataAll.length !== 0 && dataAll.map(item => {
                                                    return (
                                                        <DropdownItem className={style.item} onClick={() => this.getDataStock({limit: 'all', search: '', group: item.status, sap: this.state.sap, fisik: this.state.fisik, kondisi: this.state.kondisi, plant: this.state.plant})}>{item.status}</DropdownItem>
                                                    )
                                                })}
                                            </DropdownMenu>
                                            </ButtonDropdown>
                                        </div>
                                    </div>
                                    <select value={this.state.typeReport} onChange={e => this.changeType(e.target.value)} className={styleTrans.searchInput}>
                                        <option value="detail_report">Detail Report</option>
                                        <option value="dashboard">Dashboard</option>
                                    </select>
                                </div>
                                <div className={styleTrans.searchContainer}>
                                    <div className='rowCenter'>
                                        <text>Periode:</text>
                                        <Input
                                            type="select"
                                            name="month"
                                            className='ml-2'
                                            value={this.state.selectMonth}
                                            onChange={this.handleMonth}
                                        >
                                            <option value="">Pilih Bulan</option>
                                            {months.map((month, index) => (
                                                <option key={index} value={index + 1}>
                                                    {month}
                                                </option>
                                            ))}
                                        </Input>
                                        <Input
                                            type="select"
                                            className='ml-2'
                                            name="month"
                                            value={this.state.selectYear}
                                            onChange={this.handleYear}
                                        >
                                            <option value="">Pilih Tahun</option>
                                            {years.map((item, index) => (
                                                <option key={item} value={item}>
                                                    {item}
                                                </option>
                                            ))}
                                        </Input>
                                        <Button
                                        disabled={this.state.time1 === '' || this.state.time2 === '' ? true : false} 
                                        color='primary' 
                                        onClick={this.getDataTime} 
                                        className='ml-2'>
                                            Go
                                        </Button>
                                    </div>
                                    <input
                                        type="text"
                                        placeholder="Search..."
                                        onChange={this.onSearch}
                                        value={this.state.search}
                                        onKeyPress={this.onSearch}
                                        className={styleTrans.searchInput}
                                    />
                                </div>

                                <table className={`${styleTrans.table} ${dataRep.length > 0 ? styleTrans.tableFull : ''}`}>
                                    <thead>
                                        <tr>
                                            <th>No</th>
                                            <th>ASSET</th>
                                            <th>DESKRIPSI</th>
                                            <th>MERK</th>
                                            <th>PLANT</th>
                                            <th>COST CENTER</th>
                                            <th>AREA</th>
                                            <th>SATUAN</th>
                                            <th>UNIT</th>
                                            <th>LOKASI</th>
                                            <th>STATUS SAP</th>
                                            <th>STATUS FISIK</th>
                                            <th>KONDISI</th>
                                            <th>GROUPING</th>
                                            <th>ACQUIS VAL</th>
                                            <th>ACCUM DEP</th>
                                            <th>BOOK VAL</th>
                                            <th>KETERANGAN</th>
                                            <th>STATUS ASSET</th>
                                            <th>STATUS</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {newReport.length > 0 && newReport.map((item, index) => {
                                            return (
                                                <tr className={item.status_form === '0' ? 'fail' : item.status_reject === 0 ? 'note' : item.status_reject === 1 && 'bad'}>
                                                    <td>{index + 1}</td>
                                                    <td>{item.no_asset}</td>
                                                    <td>{item.new_status === 'Belum submit' ? item.nama_asset : item.deskripsi}</td>
                                                    <td>{item.merk}</td>
                                                    <td>{item.kode_plant}</td>
                                                    <td>{item.cost_center}</td>
                                                    <td>{item.area}</td>
                                                    <td>{item.satuan}</td>
                                                    <td>{item.unit}</td>
                                                    <td>{item.lokasi}</td>
                                                    <td>{item.new_status === 'Belum submit' ? 'ADA' : item.status_doc === 1 ? 'TIDAK ADA' : 'ADA'}</td>
                                                    <td style={{textTransform: 'uppercase'}}>{item.status_fisik}</td>
                                                    <td style={{textTransform: 'uppercase'}}>{item.kondisi}</td>
                                                    <td>{item.grouping}</td>
                                                    <td>{item.nilai_acquis}</td>
                                                    <td>{item.accum_dep}</td>
                                                    <td>{item.nilai_buku}</td>
                                                    <td>{item.keterangan}</td>
                                                    <td>{item.clear_flag}</td>
                                                    <td>{item.new_status}</td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </>
                        ) : (
                            <StockDashboard
                                newReport={this.state.newReport}
                                nilaiAcquis={this.state.nilai_acquis}
                                accumDep={this.state.accum_dep}
                                nilaiBuku={this.state.nilai_buku}
                                typeReport={this.state.typeReport}
                                time1={this.state.time1}
                                time2={this.state.time2} 
                                downloadReport={this.downloadReport}
                                onTypeChange={(val) => this.setState({ typeReport: val })}
                                onPeriodeChange={({ time1, time2, selectMonth, selectYear }) => {
                                    this.setState({ time1, time2, selectMonth, selectYear }, () => {
                                    this.getDataTime()
                                    })
                                }}
                                onDrillDown={(f) => {
                                    // f selalu punya: group, kondisi, fisik, sap, plant, status, label
                                    this.setState({ typeReport: 'detail_report' }, () => {
                                    this.getDataStock({
                                        limit:   'all',
                                        search:  '',
                                        group:   f.group,    // 'all' atau nama grouping
                                        sap:     f.sap,      // 'all', 'ada', 'null'
                                        fisik:   f.fisik,    // 'all', 'ada', 'tidak ada'
                                        kondisi: f.kondisi,  // 'all', 'baik', 'rusak', 'sedang', ''
                                        plant:   f.plant,    // 'all' atau kode_plant
                                    })
                                    })
                                }}
                            />
                        )}
                        {newReport.length === 0 && (
                            <div className={style.spinCol}>
                                <AiOutlineInbox size={50} className='secondary mb-4' />
                                <div className='textInfo'>Data ajuan tidak ditemukan</div>
                            </div>
                        )}
                    </div>
                </div>
                <Modal toggle={this.openIssue} isOpen={this.state.modalIssue} size='xl' className='xl'>
                    <ModalHeader>Issue Stock Opname</ModalHeader>
                    <ModalBody>
                        <Table responsive striped>
                            <thead>
                                <tr>
                                    <th>
                                        <Input 
                                            addon
                                            type="checkbox"
                                            className='mr-3'
                                            checked={listIssue.length === dataIssue.length ? true : false}
                                            onClick={listIssue.length === dataIssue.length ? () => this.issueRej('all') : () => this.issueApp('all')}
                                        />
                                    </th>
                                    <th>No</th>
                                    <th>FOLLOW UP</th>
                                    <th>ASSET</th>
                                    <th>DESKRIPSI</th>
                                     <th>STATUS SAP</th>
                                    <th>STATUS FISIK</th>
                                    <th>KONDISI</th>
                                    <th>GROUPING</th>
                                    <th>NOTES DROPDOWN</th>
                                    <th>KETERANGAN</th>
                                    <th>MERK</th>
                                    <th>PLANT</th>
                                    <th>COST CENTER</th>
                                    <th>AREA</th>
                                    <th>SATUAN</th>
                                    <th>UNIT</th>
                                    <th>LOKASI</th>
                                    <th>ACQUIS VAL</th>
                                    <th>ACCUM DEP</th>
                                    <th>BOOK VAL</th>
                                    <th>STATUS ASSET</th>
                                    <th>STATUS</th>
                                </tr>
                            </thead>
                            <tbody>
                                {dataIssue.length > 0 && dataIssue.map((item, index) => {
                                    return (
                                        <tr className={dataDropdown.find(x => x.description === item.notes_dropdown && x.mark) && 'bad'}>
                                            <td>
                                                <Input
                                                    addon
                                                    checked={listIssue.find(element => element === item.id) ? true : false}
                                                    type="checkbox"
                                                    onClick={listIssue.find(element => element === item.id) === undefined ? () => this.issueApp(item.id) : () => this.issueRej(item.id)}
                                                />
                                            </td>
                                            <td>{index + 1}</td>
                                            <td>
                                                <Input
                                                    key={item.id}
                                                    type="text"
                                                    name="fu_issue"
                                                    className='fillFu'
                                                    value={item.fu_issue}
                                                    onChange={(e) => this.handleFu(e, item.id)}
                                                />
                                            </td>
                                            <td>{item.no_asset}</td>
                                            <td>{item.new_status === 'Belum submit' ? item.nama_asset : item.deskripsi}</td>
                                            <td>{item.new_status === 'Belum submit' ? 'ADA' : item.status_doc === 1 ? 'TIDAK ADA' : 'ADA'}</td>
                                            <td style={{textTransform: 'uppercase'}}>{item.status_fisik}</td>
                                            <td style={{textTransform: 'uppercase'}}>{item.kondisi}</td>
                                            <td>{item.grouping}</td>
                                            <td>{item.notes_dropdown}</td>
                                            <td>{item.keterangan}</td>
                                            <td>{item.merk}</td>
                                            <td>{item.kode_plant}</td>
                                            <td>{item.cost_center}</td>
                                            <td>{item.area}</td>
                                            <td>{item.satuan}</td>
                                            <td>{item.unit}</td>
                                            <td>{item.lokasi}</td>
                                            <td>{item.nilai_acquis}</td>
                                            <td>{item.accum_dep}</td>
                                            <td>{item.nilai_buku}</td>
                                            <td>{item.clear_flag}</td>
                                            <td>{item.new_status}</td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </Table>
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={this.prepSendEmail} color='primary'>
                            Submit
                        </Button>
                        <Button onClick={this.openIssue} className='ml-1' color='secondary'>
                            Close
                        </Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.openDraft} size='xl' className='xl'>
                    <ModalHeader>Email Pemberitahuan</ModalHeader>
                    <ModalBody>
                        <Email handleData={this.getMessage} dataIssue={dataIssue} listIssue={listIssue} />
                        <div className={style.foot}>
                            <div></div>
                            <div>
                                <Button
                                    disabled={this.state.message === '' ? true : false} 
                                    className="mr-2"
                                    onClick={() => this.sendEmailIssue()} 
                                    color="primary"
                                >
                                    Submit & Send Emails
                                </Button>
                                <Button className="mr-3" onClick={this.openDraftEmail}>Cancel</Button>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
                <Modal isOpen={isLoadingAll} size="sm">
                        <ModalBody>
                        <div>
                            <div className={style.cekUpdate}>
                                <Spinner />
                                <div sucUpdate>Waiting....</div>
                            </div>
                        </div>
                        </ModalBody>
                </Modal>
                <Modal isOpen={this.state.modalConfirm} toggle={this.openConfirm} size="md">
                    <ModalBody>
                        {this.state.confirm === 'success' ? (
                            <div>
                                <div className={style.cekUpdate}>
                                    <AiFillCheckCircle size={80} className={style.green} />
                                    <div className={[style.sucUpdate, style.green]}>Berhasil Kirim Email</div>
                                </div>
                            </div>
                        ) : (
                            <div></div>
                        )}
                    </ModalBody>
                </Modal>
            </>
        )
    }
}

const mapStateToProps = state => ({
    stock: state.stock,
    depo: state.depo,
    asset_history: state.asset_history,
    status_stock: state.status_stock,
    tempmail: state.tempmail
})

const mapDispatchToProps = {
    logout: auth.logout,
    getReportAll: stock.getReportAll,
    getStatusAll: stock.getStatusAll,
    getDepo: depo.getDepo,
    getAsset: asset_history.getAsset,
    getDropdown: status_stock.getDropdown,
    getAllStatusStock: status_stock.getAllStatusStock,
    getDraftEmail: tempmail.getDraftEmail,
    sendEmail: tempmail.sendEmail,
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportStock)
